import { Injectable, inject } from '@angular/core';
import { Subject, of } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { debounceTime, switchMap, catchError } from 'rxjs/operators';
import { Inet, UserInet } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class InetService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  public getMoreInets = new Subject<{limit: number, since: Date, search: string}>();

  getInets() {
    const route = `${this.configUrl}a/i/exploreInet`;
    return this.getMoreInets.pipe(
      debounceTime(300),
      // switch to new search observable each time the term changes
      switchMap( ({limit, since, search}) => {
        const params = new HttpParams({
          fromObject: {
            limit: limit.toString(),
            since: since?.toISOString(),
            search,
          },
        });
        return this.http.get<{rows: Inet[], count: number}>(route, {params}).pipe(
          catchError( (err) => {
            if (err.error?.error === '999941') {
              return of({error: 999941});
            }
            throw err;
          }),
        );
      }),
    );
  }

  getInetsUsers(userId: number, inet: string) {
    const route = `${this.configUrl}a/i/usersInets`;
    const params = new HttpParams({
      fromObject: {
        userId: userId?.toString(),
        inet: inet?.toString(),
      },
    });
    return this.http.get<{userInets: UserInet[]}>(route, {params}).pipe();
  }

  blockInet(inet: string, newValue: boolean) {
    const route = `${this.configUrl}a/i/blockInet`;
    return this.http.post<{ affectedCount: number, sucess: boolean }>(route, {
      inet,
      newValue,
    }).pipe();
  }

  updateInet(inet: string, newData: Partial<Inet>) {
    const route = `${this.configUrl}a/i/updateInet`;
    return this.http.post<{ affectedCount: number, sucess: boolean }>(route, {
      newData,
      inet,
    }).pipe();
  }

}
